<style lang="scss" scoped>
.invalid-feedback {
  display: block;
}
</style>

<template>
  <div>
    <el-select
      class="select-primary"
      :class="{ 'is-invalid': hasErrors }"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event)"
    >
      <el-option
        v-for="(label, value) in options"
        class="select-primary"
        :value="value"
        :label="label"
        :key="value"
      >
      </el-option>
    </el-select>
    <div
      v-if="hasErrors"
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script lang="babel">
import { Select, Option } from 'element-ui'
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option
  },
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    }
  },
  computed: {
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    options() {
      return this.attribute.options;
    },
    placeholder() {
      return 'Auswählen';
    }
  }
}
</script>
